import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=adb5afa8&scoped=true&"
import script from "./Order.vue?vue&type=script&lang=js&"
export * from "./Order.vue?vue&type=script&lang=js&"
import style0 from "./Order.vue?vue&type=style&index=0&id=adb5afa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb5afa8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adb5afa8')) {
      api.createRecord('adb5afa8', component.options)
    } else {
      api.reload('adb5afa8', component.options)
    }
    module.hot.accept("./Order.vue?vue&type=template&id=adb5afa8&scoped=true&", function () {
      api.rerender('adb5afa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/components/Order.vue"
export default component.exports